import { Flex, Text, Tooltip } from 'ui';
import type { EventParticipantRoleOption } from '../hooks';

type P = {
  option: EventParticipantRoleOption;
};

const EventParticipantRoleSelectOption = ({ option: { icon, label, tooltip } }: P) => (
  <Tooltip placement="right" title={tooltip}>
    <Flex align="center" gap="small">
      {icon}
      <Text>{label}</Text>
    </Flex>
  </Tooltip>
);

export default EventParticipantRoleSelectOption;
